import toast from 'not-a-toast';

const toastTypes = {
    success: {
        theme: 'limitlessSuccess',
        iconType: 'success',
    },
    danger: {
        theme: 'limitlessDanger',
        iconType: 'error',
    },
    warning: {
        theme: 'limitlessWarning',
        iconType: 'warn',
    },
    info: {
        theme: 'limitlessInfo',
        iconType: 'info',
    },
};

export const showToast = (message, type = 'info', options = {}) => {
    const toastType = toastTypes[type] || toastTypes.info;

    return toast({
        duration: 4000,
        position: 'top-right',
        entryAnimation: 'slideInRight',
        exitAnimation: 'slideOutRight',
        showIcon: true,
        ...toastType,
        ...options,
        message,
    });
};

const toastService = {
    show: showToast,
    success: (message, options = {}) => showToast(message, 'success', options),
    danger: (message, options = {}) => showToast(message, 'danger', options),
    warning: (message, options = {}) => showToast(message, 'warning', options),
    info: (message, options = {}) => showToast(message, 'info', options),
    loading: (message, options = {}) => showToast(message, 'info', {
        duration: 0,
        iconType: 'loader',
        ...options,
    }),
};

export default toastService;
